export const B2BIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <g clipPath="url(#clip0_1_13625)">
        <path
          d="M4.6875 5.85938V3.51562C4.6875 2.22123 5.73686 1.17188 7.03125 1.17188H9.375C10.6694 1.17188 11.7188 2.22123 11.7188 3.51562V5.85938"
          stroke="white"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.2344 12.8906C15.2344 14.185 14.185 15.2344 12.8906 15.2344H3.51562C2.22123 15.2344 1.17188 14.185 1.17188 12.8906V8.20312C1.17188 6.90873 2.22123 5.85938 3.51562 5.85938H12.8906C14.185 5.85938 15.2344 6.90873 15.2344 8.20312V12.8906Z"
          stroke="white"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.4844 28.8281H17.1094C15.815 28.8281 14.7656 27.7788 14.7656 26.4844V21.7969C14.7656 20.5025 15.815 19.4531 17.1094 19.4531H26.4844C27.7788 19.4531 28.8281 20.5025 28.8281 21.7969V26.4844C28.8281 27.7788 27.7788 28.8281 26.4844 28.8281Z"
          stroke="white"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.6875 5.625H24.1406C26.7295 5.625 28.8281 7.72365 28.8281 10.3125"
          stroke="white"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.5669 9.8899L20.081 7.404C19.1657 6.48871 19.1657 5.00471 20.081 4.08941L22.5669 1.60352"
          stroke="white"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.17188 19.6826C1.17188 22.2715 3.27053 24.3701 5.85938 24.3701H10.2539"
          stroke="white"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.08105 28.593L9.56695 26.1071C10.4822 25.1918 10.4822 23.7078 9.56695 22.7925L7.08105 20.3066"
          stroke="white"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.2812 19.4531V17.1094C18.2812 15.815 19.3306 14.7656 20.625 14.7656H22.9688C24.2631 14.7656 25.3125 15.815 25.3125 17.1094V19.4531"
          stroke="white"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.20312 5.85938V8.20312"
          stroke="white"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.7969 19.4531V21.7969"
          stroke="white"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_13625">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
